import useLegalDocumentRepository from "../../../../repository/user/useLegalDocumentRepository";
import {useEffect, useRef, useState} from "react";
import useLegalDocumentTemplateRepository from "../../../../repository/user/useLegalDocumentTemplateRepository";
import {Button, Chip, CircularProgress} from "@mui/material";
import {AddAPhoto} from "@mui/icons-material";
import useHelper from "../../../../use/useHelper";
import Box from "@mui/material/Box";
import isNull from "../../../../mixin/isNull";
import LegalDocument from "../../../../entity/user/LegalDocument";
import Typography from "@mui/material/Typography";
import Compressor from 'compressorjs';

export default function ({legalDocumentId}) {
    const helper = useHelper();
    const legalDocumentRepository = useLegalDocumentRepository();
    const legalDocumentTemplateRepository = useLegalDocumentTemplateRepository();
    /** @type LegalDocumentTemplate[] */
    const legalDocumentTemplates = legalDocumentTemplateRepository.findAll().select();
    /** @type LegalDocument */
    const legalDocument = legalDocumentRepository.findOneById(legalDocumentId).select();
    /** @type LegalDocument */
    const renewalOf = legalDocumentRepository.findOneById(legalDocument?.getRenewalOfLegalDocumentId()).select();
    const [loading, setLoading] = useState(false);
    const pictureInput = useRef();

    useEffect(() => {
        legalDocumentRepository.findOneById(legalDocumentId).exec();
        legalDocumentTemplateRepository.findAll().exec();
    }, []);

    useEffect(() => {
        if (isNull(legalDocument) || isNull(legalDocument.getRenewalOfLegalDocumentId())) return;

        legalDocumentRepository.findOneById(legalDocument.getRenewalOfLegalDocumentId()).exec();
    }, [JSON.stringify(legalDocument)]);


    const handleTakePictureClicked = () => pictureInput.current.click();

    const handleUpload = e => {
        const file = e.target.files[0];
        if (file.type.startsWith("image")) {

            const options = {
                quality: 0.3,

                // Compression success callback
                success: async result => {
                    const res = await helper.inputFileToRequestFile(result);

                    submit(res);
                }
            };

            new Compressor(file, options);
        } else {
            const reader = new FileReader();

            reader.onload = ((f) => (e) => {
                let contentType = file.type;
                let content = e.target.result.replace("data:" + contentType + ";base64,", "");

                submit({"content": content, "content-type": contentType});
            })(file);
            reader.readAsDataURL(file);
        }
    }

    const submit = async document => {
        await legalDocumentRepository.update(legalDocumentId, "document_id", {
            uploaded_file: {
                legal_document_document: document
            }
        });
    }


    return (
        <Box mt={15} data-test="upload-legal-document-modal">

            {
                !isNull(renewalOf) && renewalOf.getStatus() === LegalDocument.STATUS_REFUSED
                    ? (
                        <Box>
                            <Chip color={"warning"}
                                  label={"Votre dernier document a été refusée :"}
                                  size={"small"}/>
                            <Typography>{renewalOf.getRefuseReason()}</Typography>
                        </Box>
                    )
                    : null
            }

            <Box mt={5}>

                <Button
                    startIcon={loading ? <CircularProgress size={20} color={"inherit"}/> : <AddAPhoto/>}
                    variant={"contained"}
                    fullWidth
                    onClick={handleTakePictureClicked}
                    disabled={loading}
                    data-test="button-picture"
                >
                    Prendre en photo
                </Button>
                <input
                    ref={pictureInput}
                    style={{display: "none"}}
                    type={"file"}
                    accept="image/*"
                    onChange={handleUpload}
                    data-test="input-file"
                />
            </Box>
        </Box>
    );

}